import { node, number, string } from "prop-types";
import { useDroppable } from "@dnd-kit/react";
import { Grid } from "@material-ui/core";
import useCellStyle from "@tools/EstimateEditor/styles/CommonTableCellStyles.style";
import classnames from "classnames";
import { makeStyles } from "@material-ui/styles"
import { useEstimateEditorSettings } from "@tools";

export const TimelineSectionDroppable = ({
  sectionId,
  week,
  children,
  className,
}) => {
  const { allowEdition } = useEstimateEditorSettings();
  const classes = useStyle();
  const cellClasses = useCellStyle();
  
  const { ref, isDropTarget } = useDroppable({
    id: `${sectionId}-${week}`,
    data: { week },
    disabled: !allowEdition,
  })
  
  return (
    <Grid
      item container
      alignItems="center"
      className={classnames(
        "h-full",
        cellClasses.fullDashBorderRight,
        className,
      )}
    >
      <Grid
        item container
        ref={ref}
        alignItems="center"
        className={classnames(
          "h-full relative rounded-2",
          isDropTarget && classes.isOver
        )}
      >
        {children}
      </Grid>
    </Grid>
  );
};

TimelineSectionDroppable.propTypes = {
  sectionId: string.isRequired,
  week: number.isRequired,
  children: node,
  className: string,
};
const useStyle = makeStyles(( theme ) => ({
  isOver: {
    backgroundColor: theme.palette.primary.main+"20"
  }
}));